export const ProductDataMethodMapping = {
  "Regenerante (Hairloss Control)": {
    color: "#B9A5DE",
    Product: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Flabiosthetique_product1.jpg?alt=media",
      description: "Intensive Wirkstoffpflege für Haarwachstum",
      value: "regenerante_hairloss_control_method",
      title: "Regenerante (Hairloss Control)",
      items: [
        {
          step: "Schritt 1",
          title: "Hairloss Control Shampoo",
          description:
            "Das milde Shampoo revitalisiert die Haarwurzeln, macht das Haar widerstandsfähiger und hilft, Haarausfall vorzubeugen.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep1_regenerante.jpg?alt=media",
          value: "hairloss_control_shampoo",
        },
        {
          step: "Schritt 2",
          title: "Hairloss Control Scalp Lotion",
          description:
            "Die Kopfhautlotion verlangsamt die Alterungsprozesse, stärkt das Haarwachstum, verbessert die Haardichte und wirkt Haarausfall entgegen.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep2_regenerante.jpg?alt=media",
          value: "hairloss_control_scalp_lotion",
        },
        {
          step: "Schritt 3",
          title: "Hairloss Control Scalp Concentrate",
          description:
            "Das Kopfhautkonzentrat revitalisiert die Haarwurzeln und verlängert den Lebenszyklus der Haare.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep3_regenerante.jpg?alt=media",
          value: "hairloss_control_scalp_concentrate",
        },
        {
          step: "Schritt 4",
          title: "Anti-Grey Elixir",
          description:
            "Das einzigartige Kopfhautelixier revitalisiert ergrautes Haar und verhilft ihm zu seiner natürlichen Farbe zurück.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep4_regenerante.jpg?alt=media",
          value: "anti_grey_elixir",
        },
        {
          step: "Schritt 5",
          title: "Fortifying Shampoo",
          description:
            "Das milde Shampoo stärkt die Haarwurzeln, schenkt geschwächtem, brüchigem Haar neue Kraft und bereitet die Kopfhaut auf die nachfolgende Pflege gegen Haarausfall und Haarwachstumsstörungen vor.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep5_regenerante.jpg?alt=media",
          value: "fortifying_shampoo",
        },
        {
          step: "Schritt 6",
          title: "Fortifying Scalp Concentrate",
          description:
            "Das Kopfhautkonzentrat erhöht die Nährstoffversorgung der Haarwurzeln, wirkt Haarausfall entgegen und sorgt für dichteres, kräftigeres Haar.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep6_regenerante.jpg?alt=media",
          value: "fortifying_scalp_concentrate",
        },
        {
          step: "Schritt 7",
          title: "Vitalising Scalp Concentrate",
          description:
            "Die Ampullenkur nährt die Kopfhaut und verbessert spürbar und sichtbar die Qualität von Haaren mit nachlassender Fülle, Sprungkraft und Widerstandskraft infolge von Störungen im Bereich essenzieller Spurenelemente, Mineralien und Vitamine.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep7_regenerante.jpg?alt=media",
          value: "vitalising_scalp_concentrate",
        },
        {
          step: "Schritt 8",
          title: "Fortifying Aroma Complex",
          description:
            "Der Aromakomplex nutzt die therapeutischen Kräfte etherischer Öle, um die Kopfhautfunktionen zu stimulieren, das gesunde Haarwachstum zu fördern und ein harmonisches Wohlgefühl zu verleihen.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep8_regenerante.jpg?alt=media",
          value: "fortifying_aroma_complex",
        },
        {
          step: "Schritt 9",
          title: "Hair & Nail Strengthening Food Supplement",
          description:
            "Das Nahrungsergänzungsmittel trägt von innen heraus zur wirksamen Behandlung von Haarausfall sowie Nagelbruch bei und fördert das Wachstum schöner, vitaler Haare und Nägel.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep9_regenerante.jpg?alt=media",
          value: "hair_nail_strengthening_food_supplement",
        },
      ],
    },
    Treatment: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FTreatments%2FKopfhautmassage%20mit%20Ampulle.jpg?alt=media",
      description: "Kopfhautmassage mit Ampulle",
      value: "kopfhautmassage_mit_ampulle",
    },
  },
  "Sensitive (Dandruff)": {
    color: "#E390A1",
    Product: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Flabiosthetique_product2.jpg?alt=media",
      description: "Synergiepflege bei Schuppen und sensibler Kopfhaut",
      value: "sensitive_dandruff_method",
      title: "Sensitive",
      items: [
        {
          step: "Schritt 1",
          title: "Calming Lipokerine E Shampoo",
          description:
            "Das parfumfreie Shampoo reinigt besonders mild, beruhigt empfindliche Kopfhaut und baut strapaziertes Haar wieder auf.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep1_sensitive.jpg?alt=media",
          value: "calming_lipokerine_e_Shampoo",
        },
        {
          step: "Schritt 2",
          title: "Calming Scalp Lotion",
          description:
            "Die wohltuende Lotion beruhigt gestresste Kopfhaut, lindert Irritationen, beugt Schuppen vor und reduziert die Reizanfälligkeit empfindlicher Kopfhaut.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep2_sensitive.jpg?alt=media",
          value: "calming_scalp_lotion",
        },
        {
          step: "Schritt 3",
          title: "Calming Aroma Complex",
          description:
            "Der Aromakomplex nutzt die therapeutischen Kräfte etherischer Öle, um empfindliche Kopfhaut in ihr gesundes Gleichgewicht zurückzubringen und das allgemeine Wohlbefinden zu stärken.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep3_sensitive.jpg?alt=media",
          value: "calming_aroma_complex",
        },
        {
          step: "Schritt 4",
          title: "Purifying Dandruff Shampoo",
          description:
            "Das parfumfreie Shampoo befreit schonend und gründlich von Schuppen und beugt deren Neubildung vor.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep4_sensitive.jpg?alt=media",
          value: "purifying_dandruff_shampoo",
        },
        {
          step: "Schritt 5",
          title: "Babybios Conditioning Spray",
          description:
            "Das leichte Leave-in Pflegespray verwöhnt empfindliche Haare und sensible Kopfhaut mit beruhigenden Substanzen und einer Extraportion Feuchtigkeit.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep5_sensitive.jpg?alt=media",
          value: "babybios_conditioning_spray",
        },
      ],
    },
    Treatment: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FTreatments%2FKopfhautpeeling.jpg?alt=media",
      description: "Kopfhautpeeling",
      value: "kopfhautpeeling",
    },
  },
  "Sensitive (Sensitive)": {
    color: "#E390A1",
    Product: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Flabiosthetique_product3.jpg?alt=media",
      description: "Synergiepflege bei Schuppen und sensibler Kopfhaut",
      value: "sensitive_sensitive_method",
      title: "Sensitive",
      items: [
        {
          step: "Schritt 1",
          title: "Calming Lipokerine E Shampoo",
          description:
            "Das parfumfreie Shampoo reinigt besonders mild, beruhigt empfindliche Kopfhaut und baut strapaziertes Haar wieder auf.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep1_sensitive.jpg?alt=media",
          value: "calming_lipokerine_e_Shampoo",
        },
        {
          step: "Schritt 2",
          title: "Calming Scalp Lotion",
          description:
            "Die wohltuende Lotion beruhigt gestresste Kopfhaut, lindert Irritationen, beugt Schuppen vor und reduziert die Reizanfälligkeit empfindlicher Kopfhaut.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep2_sensitive.jpg?alt=media",
          value: "calming_scalp_lotion",
        },
        {
          step: "Schritt 3",
          title: "Calming Aroma Complex",
          description:
            "Der Aromakomplex nutzt die therapeutischen Kräfte etherischer Öle, um empfindliche Kopfhaut in ihr gesundes Gleichgewicht zurückzubringen und das allgemeine Wohlbefinden zu stärken.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep3_sensitive.jpg?alt=media",
          value: "calming_aroma_complex",
        },
        {
          step: "Schritt 4",
          title: "Purifying Dandruff Shampoo",
          description:
            "Das parfumfreie Shampoo befreit schonend und gründlich von Schuppen und beugt deren Neubildung vor.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep4_sensitive.jpg?alt=media",
          value: "purifying_dandruff_shampoo",
        },
        {
          step: "Schritt 5",
          title: "Babybios Conditioning Spray",
          description:
            "Das leichte Leave-in Pflegespray verwöhnt empfindliche Haare und sensible Kopfhaut mit beruhigenden Substanzen und einer Extraportion Feuchtigkeit.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep5_sensitive.jpg?alt=media",
          value: "babybios_conditioning_spray",
        },
      ],
    },
    Treatment: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FTreatments%2FKopfhautmassage%20mit%20Lotion.jpg?alt=media",
      description: "Kopfhautmassage mit Lotion",
      value: "kopfhautmassage_mit_lotion",
    },
  },
  Clarifiante: {
    color: "#A6D4AC",
    Product: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Flabiosthetique_product4.jpg?alt=media",
      description:
        "Ausgleichende und klärende Pflege bei fettiger und feuchter Kopfhaut",
      value: "clarifiante_method",
      title: "Clarifiante",
      items: [
        {
          step: "Schritt 1",
          title: "Balancing Lipokerine A Shampoo",
          description:
            "Das ausgleichende Shampoo reinigt ebenso schonend wie gründlich, befreit die Kopfhaut von überschüssigem Talg, reguliert die Talgproduktion und verhindert das schnelle Nachfetten der Haare.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep1_clarifiante.jpg?alt=media",
          value: "balancing_lipokerine_a_shampoo",
        },
        {
          step: "Schritt 2",
          title: "Moisture Control Shampoo",
          description:
            "Während es Kopfhaut und Haare mild reinigt, reduziert das Shampoo das Austreten von Schweiß aus den Kopfhautporen und sorgt für länger andauernde Frische.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep2_clarifiante.jpg?alt=media",
          value: "moisture_control_shampoo",
        },
        {
          step: "Schritt 3",
          title: "Moisture Control Scalp Lotion",
          description:
            "Die Pflegelotion neutralisiert die durch starkes Schwitzen freigesetzten aggressiven Substanzen und beruhigt die Kopfhaut.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep3_clarifiante.jpg?alt=media",
          value: "moisture_control_scalp_lotion",
        },
        {
          step: "Schritt 4",
          title: "Refreshing Aroma Complex",
          description:
            "Der Aromakomplex nutzt die therapeutischen Kräfte etherischer Öle, um die fettige oder feuchte Kopfhaut zu klären und ein anhaltendes Frischegefühl zu verleihen.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep4_clarifiante.jpg?alt=media",
          value: "refreshing_aroma_complex",
        },
      ],
    },
    Treatment: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FTreatments%2FKopfhautmassage%20mit%20Lotion.jpg?alt=media",
      description: "Kopfhautmassage mit Lotion",
      value: "kopfhautmassage_mit_lotion",
    },
  },
  Hydratante: {
    color: "#82C7E6",
    Product: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Flabiosthetique_product5.jpg?alt=media",
      description: "Feuchtigkeit spendende Pflege bei trockener Kopfhaut",
      value: "hydratante_method",
      title: "Hydratante",
      items: [
        {
          step: "Schritt 1",
          title: "Restoring Lipokerine B Shampoo",
          description:
            "Das sanft reinigende Shampoo stärkt den natürlichen Hydrolipidfilm der Kopfhaut, unterstützt die Feuchtigkeitsbindung und schützt Kopfhaut und Haar vor dem Austrocknen.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep1_hydratante.jpg?alt=media",
          value: "restoring_lipokerine_b_shampoo",
        },
        {
          step: "Schritt 2",
          title: "Restoring Scalp Lotion",
          description:
            "Die Feuchtigkeit spendende Kopfhautpflege versorgt die Haut intensiv mit Feuchtigkeit, bindet sie nachhaltig und stärkt die natürliche Schutzbarriere.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep2_hydratante.jpg?alt=media",
          value: "restoring_scalp_lotion",
        },
        {
          step: "Schritt 3",
          title: "Restoring Scalp Oil",
          description:
            "Wertvolle Öle regenerieren die Kopfhaut, stärken ihre natürliche Barrierefunktion und lindern trockenheitsbedingte Spannungsgefühle und Irritationen.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep3_hydratante.jpg?alt=media",
          value: "restoring_scalp_oil",
        },
        {
          step: "Schritt 4",
          title: "Energising Aroma Complex",
          description:
            "Der Aromakomplex nutzt die therapeutischen Kräfte etherischer Öle, um die Kopfhautfunktionen zu stimulieren, trockene Haut zu regenerieren und ein belebendes Wohlgefühl zu verleihen.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep4_hydratante.jpg?alt=media",
          value: "energising_aroma_complex",
        },
      ],
    },
    Treatment: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FTreatments%2FKopfhautmassage%20mit%20Lotion.jpg?alt=media",
      description: "Kopfhautmassage mit Lotion",
      value: "kopfhautmassage_mit_lotion",
    },
  },
};

export const ProductDataSolutionMapping = {
  "Long Hair": {
    color: "#B60056",
    Product: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Flabiosthetique_product6.jpg?alt=media",
      description: "Intensive Pflege und Rundumschutz für langes Haar",
      value: "long_hair_solution",
      title: "Long Hair",
      items: [
        {
          step: "Schritt 1",
          title: "Long Hair Protective Volumising Shampoo",
          description:
            "Das sanfte Mizellen Shampoo reinigt tiefenwirksam, gleicht die Haarstruktur aus, schützt vor schädigenden Umwelteinflüssen und schenkt dem Haar Volumen.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep1_longhair.jpg?alt=media",
          value: "long_hair_protective_volumising_shampoo",
        },
        {
          step: "Schritt 2",
          title: "Long Hair Protective Softening Shampoo",
          description:
            "Das sanfte Mizellen Shampoo reinigt tiefenwirksam, gleicht die Haarstruktur aus, schützt vor schädigenden Umwelteinflüssen und pflegt das Haar geschmeidig.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep2_longhair.jpg?alt=media",
          value: "long_hair_protective_softening_shampoo",
        },
        {
          step: "Schritt 3",
          title: "Long Hair Growth Booster",
          description:
            "Die Power Pflege für Haarwurzeln und Kopfhaut stimuliert die Aktivität der haarbildenden Zellen und beschleunigt das Wachstum gesunder, kräftiger Haare.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep3_longhair.jpg?alt=media",
          value: "Long Hair Growth Booster",
        },
        {
          step: "Schritt 4",
          title: "Long Hair Detangler",
          description:
            "Das mehrfach wirksame Serum zum Aufsprühen spendet langem Haar schwerelose Feuchtigkeit und Pflege, gleicht die Haarstruktur minutenschnell aus und entwirrt.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep4_longhair.jpg?alt=media",
          value: "Long Hair Detangler",
        },
        {
          step: "Schritt 5",
          title: "Long Hair Protective Repair Mask",
          description:
            "Nähr- und Pflegestoffe bauen das Haar von innen her auf und schützen es von außen.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep5_longhair.jpg?alt=media",
          value: "Long Hair Protective Repair Mask",
        },
        {
          step: "Schritt 6",
          title: "Long Hair Protective Conditioning Fluid",
          description:
            "Im Handumdrehen angewandt, spendet das Leave-In Pflegefluid dem Haar Feuchtigkeit, gleicht Strukturunterschiede aus und schützt es vor Haarbruch, Schadstoffpartikeln und anderen schädlichen Umwelteinflüssen.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep6_longhair.jpg?alt=media",
          value: "Long Hair Protective Conditioning Fluid",
        },
        {
          step: "Schritt 7",
          title: "Long Hair Weightless Conditioning Oil",
          description:
            "Das kostbare Öl versorgt langes Haar mit schwereloser Feuchtigkeit und Pflege, macht es geschmeidig und verleiht intensiven Glanz.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep7_longhair.jpg?alt=media",
          value: "Long Hair Weightless Conditioning Oil",
        },
        {
          step: "Schritt 8",
          title: "Long Hair Refreshing Dry Shampoo",
          description:
            "Mit feinstem Reisstärkepuder absorbiert Refresh Dry Shampoo überschüssige Öle. Ansätze und Längen werden auf natürliche Weise aufgefrischt.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep8_longhair.jpg?alt=media",
          value: "Long Hair Refreshing Dry Shampoo",
        },
      ],
    },
    Treatment: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FTreatments%2FIntensivhaarpflege.jpg?alt=media",
      description: "Intensivhaarpflege",
      value: "intensivhaarpflege",
    },
  },
  "Structure Repair": {
    color: "#5CA3B4",
    Product: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Flabiosthetique_product7.jpg?alt=media",
      description:
        "Nährende Pflege für trockenes, stark strukturgeschädigtes Haar",
      value: "structure_repair_solution",
      title: "Structure Repair",
      items: [
        {
          step: "Schritt 1",
          title: "Structure Repair Nourishing Shampoo",
          description:
            "Das Feuchtigkeit spendende Shampoo wirkt Struktur ausgleichend und macht trockenes, geschädigtes Haar herrlich geschmeidig und seidig glänzend.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep1_structurerepair.jpg?alt=media",
          value: "Structure Repair Nourishing Shampoo",
        },
        {
          step: "Schritt 2",
          title: "Structure Repair Nourishing Conditioner",
          description:
            "Angereichert mit kostbaren Ölen nährt der Conditioner trockenes, stark geschädigtes Haar, spendet Feuchtigkeit und sorgt für maximale Geschmeidigkeit, verbesserte Kämmbarkeit und Glanz.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep2_structurerepair.jpg?alt=media",
          value: "Structure Repair Nourishing Conditioner",
        },
        {
          step: "Schritt 3",
          title: "Structure Repair Nourishing Conditioning Spray",
          description:
            "Sofort beim Aufsprühen nährt das intensiv pflegende Leave-in Spray angegriffenes Haar mit wertvollen Ölen, gleicht Strukturschäden aus und erleichtert das Kämmen.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep3_structurerepair.jpg?alt=media",
          value: "Structure Repair Nourishing Conditioning Spray",
        },
        {
          step: "Schritt 4",
          title: "Structure Repair Nourishing Mask",
          description:
            "Wertvolle Öle und Nährstoffe bauen stark geschädigtes Haar tiefenwirksam auf, versiegeln seine Oberfläche und sorgen für glanzvolle Geschmeidigkeit.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep4_structurerepair.jpg?alt=media",
          value: "Structure Repair Nourishing Mask",
        },
        {
          step: "Schritt 5",
          title: "Structure Repair Hydrating Drops",
          description:
            "Pur oder als Intensivierung der gewohnten Haarpflege pflegen die innovativen Drops trockenes, strapaziertes Haar mit einer Extraportion Feuchtigkeit.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep5_structurerepair.jpg?alt=media",
          value: "Structure Repair Hydrating Drops",
        },
      ],
    },
    Treatment: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FTreatments%2FIntensivhaarpflege.jpg?alt=media",
      description: "Intensivhaarpflege",
      value: "intensivhaarpflege",
    },
  },
  "Colour Protection": {
    color: "#DC7597",
    Product: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Flabiosthetique_product8.jpg?alt=media",
      description:
        "Pflege und Schutz für coloriertes und chemisch behandeltes Haar",
      value: "colour_protection_solution",
      title: "Colour Protection",
      items: [
        {
          step: "Schritt 1",
          title: "Colour Protection Shine Restoring Pre-Shampoo Treatment",
          description:
            "Die intensiv pflegende Vorbehandlung schützt das Haar während der Haarwäsche vor Feuchtigkeits– und Farbverlust, für herrlich geschmeidiges, gesund glänzendes Haar.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep1_colourprotection.jpg?alt=media",
          value: "Colour Protection Shine Restoring Pre-Shampoo Treatment",
        },
        {
          step: "Schritt 2",
          title: "Colour Protection Shine Restoring Volumising Shampoo",
          description:
            "Das sulfatfreie Shampoo reinigt besonders sanft, schützt die Haarfarbe vor Verblassen sowie Auswaschen und sichert lang anhaltende Farbbrillanz.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep2_colourprotection.jpg?alt=media",
          value: "Colour Protection Shine Restoring Volumising Shampoo",
        },
        {
          step: "Schritt 3",
          title: "Colour Protection Shine Restoring Softening Shampoo",
          description:
            "Das milde Shampoo reinigt coloriertes, strapaziertes Haar und versorgt es mit Feuchtigkeit und Pflege.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep3_colourprotection.jpg?alt=media",
          value: "Colour Protection Shine Restoring Softening Shampoo",
        },
        {
          step: "Schritt 4",
          title: "Colour Protection Shine Restoring Conditioner",
          description:
            "Ohne zu beschweren, entwirrt und pflegt der Conditioner chemisch behandeltes Haar, schließt Farbpigmente im Haarinneren ein, schützt vor negativen Umwelteinflüssen und sorgt für Geschmeidigkeit, Farbbrillanz und Glanz.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep4_colourprotection.jpg?alt=media",
          value: "Colour Protection Shine Restoring Conditioner",
        },
        {
          step: "Schritt 5",
          title: "Colour Protection Shine Restoring Conditioning Fluid",
          description:
            "Das Leave-in Fluid mit integriertem Hitzeschutz nährt und pflegt das Haar tiefenwirksam.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep5_colourprotection.jpg?alt=media",
          value: "Colour Protection Shine Restoring Conditioning Fluid",
        },
        {
          step: "Schritt 6",
          title: "Colour Protection Structure Restoring Treatment",
          description:
            "In zwei Phasen repariert und regeneriert die Intensivhaarpflege die innere und äußere Struktur chemisch beanspruchter Haare, stärkt das Haar, bewahrt vor Haarbruch und schützt das Haar vor negativen Umwelteinflüssen sowie frühzeitigem Farbverlust.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep6_colourprotection.jpg?alt=media",
          value: "Colour Protection Structure Restoring Treatment",
        },
      ],
    },
    Treatment: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FTreatments%2FIntensivhaarpflege.jpg?alt=media",
      description: "Intensivhaarpflege",
      value: "intensivhaarpflege",
    },
  },
  Curl: {
    color: "#DF5F13",
    Product: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Flabiosthetique_product9.jpg?alt=media",
      description: "Pflege für lockiges Haar",
      value: "curl_solution",
      title: "Curl",
      items: [
        {
          step: "Schritt 1",
          title: "Curl Activating Shampoo",
          description:
            "Das sanft reinigende Shampoo belebt und aktiviert Locken bereits beim Waschen mit extra viel Feuchtigkeit und einem exklusiven Polymer.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep1_curl.jpg?alt=media",
          value: "Curl Activating Shampoo",
        },
        {
          step: "Schritt 2",
          title: "Curl Activating Repair Mask",
          description:
            "Die intensiv pflegende Haarmaske repariert und stabilisiert die Lockenstruktur mit natürlichen Nährstoffen und schützt die Haaroberfläche vor Witterungs- und Umwelteinflüssen.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep2_curl.jpg?alt=media",
          value: "Curl Activating Repair Mask",
        },
        {
          step: "Schritt 3",
          title: "Curl Activating Conditioning Spray",
          description:
            "Die einfach anzuwendende Sprühlotion konditioniert und aktiviert Locken, verhilft ihnen zu springlebendiger Vitalität und verleiht Sprungkraft mit flexiblem Halt.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep3_curl.jpg?alt=media",
          value: "Curl Activating Conditioning Spray",
        },
        {
          step: "Schritt 4",
          title: "Curl Defining Styling Fluid",
          description:
            "Das Styling- und Finish-Fluid zähmt widerspenstige Locken mit tiefenwirksamer Feuchtigkeit.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep4_curl.jpg?alt=media",
          value: "Curl Defining Styling Fluid",
        },
      ],
    },
    Treatment: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FTreatments%2FIntensivhaarpflege.jpg?alt=media",
      description: "Intensivhaarpflege",
      value: "intensivhaarpflege",
    },
  },
  Volume: {
    color: "#E6C22D",
    Product: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Flabiosthetique_product10.jpg?alt=media",
      description: "Pflege für feines, kraftloses Haar",
      value: "volume_solution",
      title: "Volume",
      items: [
        {
          step: "Schritt 1",
          title: "Volume Strengthening Shampoo",
          description:
            "Das milde Strengthening Shampoo reinigt die Haare sanft, vitalisiert feines, dünnes Haar, kräftigt und versiegelt die Haarfaser und schafft spürbar mehr Dichte und Volumen.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep1_volume.jpg?alt=media",
          value: "Volume Strengthening Shampoo",
        },
        {
          step: "Schritt 2",
          title: "Volume Weightless Conditioner",
          description:
            "Die leichte Pflege revitalisiert und kräftigt feines Haar, verwöhnt es mit Feuchtigkeit, entwirrt es sanft und sorgt für schwereloses Volumen.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep2_volume.jpg?alt=media",
          value: "Volume Weightless Conditioner",
        },
        {
          step: "Schritt 3",
          title: "Volume Strengthening Repair Mask",
          description:
            "Die intensive Pflegemaske repariert und kräftigt das Haar tiefenwirksam, ohne es zu beschweren, beugt Haarbruch sowie Spliss vor und schafft gesundes Volumen.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep3_volume.jpg?alt=media",
          value: "Volume Strengthening Repair Mask",
        },
        {
          step: "Schritt 4",
          title: "Volume Strengthening Conditioning Spray",
          description:
            "Der praktische Leave-in Conditioner versorgt das Haar im Nu mit Pflege und Feuchtigkeit, ohne es zu beschweren.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep4_volume.jpg?alt=media",
          value: "Volume Strengthening Conditioning Spray",
        },
      ],
    },
    Treatment: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FTreatments%2FIntensivhaarpflege.jpg?alt=media",
      description: "Intensivhaarpflege",
      value: "intensivhaarpflege",
    },
  },
  "Frizz Control": {
    color: "#366099",
    Product: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Flabiosthetique_product11.jpg?alt=media",
      description: "Pflege & Style für widerspenstiges Haar",
      value: "frizz_control_solution",
      title: "Frizz Control",
      items: [
        {
          step: "Schritt 1",
          title: "Frizz Control Smoothing Shampoo",
          description:
            "Smoothing Shampoo beruhigt unruhiges Haar bereits während der Wäsche, bändigt seine Textur und schützt vor äußeren Einflüssen.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep1_frizzcontrol.jpg?alt=media",
          value: "Frizz Control Smoothing Shampoo",
        },
        {
          step: "Schritt 2",
          title: "Frizz Control Smoothing Conditioner",
          description:
            "Smoothing Conditioner stabilisiert den Feuchtigkeitshaushalt unruhiger Haare und versorgt sie mit Nährstoffen.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep2_frizzcontrol.jpg?alt=media",
          value: "Frizz Control Smoothing Conditioner",
        },
        {
          step: "Schritt 3",
          title: "Frizz Control Smoothing Styling Fluid",
          description:
            "Smoothing Styling Fluid bändigt störrisches Haar im Handumdrehen und bringt es in glänzende Form mit lebendigem Halt.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep3_frizzcontrol.jpg?alt=media",
          value: "Frizz Control Smoothing Styling Fluid",
        },
      ],
    },
    Treatment: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FTreatments%2FIntensivhaarpflege.jpg?alt=media",
      description: "Intensivhaarpflege",
      value: "intensivhaarpflege",
    },
  },
};
